/**
 * Runtime wiring for identityPipeline recovery redirects (GC-P0-06, PG-020).
 */
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { useTenantCode } from '../shared/tenant/TenantProvider.js';
import {
  mapRecoveryModeToPath,
  type IdentityPipelineRecoveryMode,
} from './identityPipeline.js';

export function useIdentityPipelineNavigation(): {
  readonly navigateRecovery: (mode: IdentityPipelineRecoveryMode) => void;
} {
  const navigate = useNavigate();
  const tenantCode = useTenantCode();

  const navigateRecovery = useCallback(
    (mode: IdentityPipelineRecoveryMode): void => {
      navigate(mapRecoveryModeToPath(tenantCode, mode), { replace: true });
    },
    [navigate, tenantCode],
  );

  return { navigateRecovery };
}
